import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { OntarioHcComponent } from './ontario-hc.component';
import { DateInputModule } from '../date-input/date-input.module';

@NgModule({
  declarations: [OntarioHcComponent],
  providers: [],
  imports: [
    CommonModule,
    NzInputModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    DateInputModule
  ],
  exports: [OntarioHcComponent]
})
export class OntarioHcModule {}
